import { IconButton, Menu, MenuItem, Typography, styled } from '@mui/material'
import React, { ReactNode, useState } from 'react'
import { MdMoreVert } from 'react-icons/md'
import { muiTheme } from '../../mui-theme'

interface ActionBarElement {
  label: string
  onClick: () => void
  Icon: ReactNode
}

interface KebabMenuProps {
  actions: Array<ActionBarElement>
  isSelected?: boolean
  anchorOrigin?: {
    vertical: 'top' | 'bottom' | 'center'
    horizontal: 'left' | 'right' | 'center'
  }
  transformOrigin?: {
    vertical: 'top' | 'bottom' | 'center'
    horizontal: 'left' | 'right' | 'center'
  }
}

const StyledIconButton = styled(IconButton)`
  width: 32px;
  height: 32px;
  color: ${muiTheme.palette.primary.main};

  &:hover {
    background-color: ${muiTheme.palette.tableRow.main};
  }
`
const StyledMenuLabel = styled(Typography)({
  fontWeight: 'normal',
})

const KebabMenu: React.FC<KebabMenuProps> = ({ actions, isSelected, anchorOrigin, transformOrigin }) => {
  const [anchorEl, setAnchorEl] = useState(null)

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <div>
      <StyledIconButton aria-controls="kebab-menu" aria-haspopup="true" onClick={handleClick} size="small">
        <MdMoreVert color={isSelected ? muiTheme.palette.white.main : ''} />
      </StyledIconButton>
      <Menu
        id="kebab-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={anchorOrigin ?? { vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={transformOrigin ?? { vertical: 'top', horizontal: 'center' }}
        MenuListProps={{
          onMouseLeave: () => setAnchorEl(null),
        }}
      >
        {actions.map((action, index) => (
          <MenuItem key={index} onClick={action.onClick} sx={{ gap: 1 }}>
            {action.Icon}
            <StyledMenuLabel variant="body1">{action.label}</StyledMenuLabel>
          </MenuItem>
        ))}
      </Menu>
    </div>
  )
}

export default KebabMenu
